import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Chọn tài khoản", -1)
const _hoisted_4 = { class: "card flex justify-content-center" }
const _hoisted_5 = { class: "flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"width":"20px"} }
const _hoisted_8 = { class: "flex align-items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"width":"20px"} }
const _hoisted_11 = { class: "p-field p-col p-col-12 p-md-3 p-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Thêm", -1)
const _hoisted_13 = { class: "p-fluid" }
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col-5 p-md-5" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_18 = { class: "p-field p-col-5 p-md-5" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Không có thông tin nhân viên. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Panel, { header: "Thêm thành viên nhận báo cáo" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Dropdown, {
                modelValue: $setup.customer,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.customer) = $event)),
                options: $setup.listCustomer,
                optionLabel: "name",
                placeholder: "Chọn tài khoản",
                filter: true,
                style: {"height":"35px"}
              }, {
                value: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_5, [
                    (slotProps.value.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: slotProps.value.imageUrl,
                          style: {"width":"20px","margin-right":"3px"}
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_7, _toDisplayString(slotProps.value.name), 1)
                  ])
                ]),
                option: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_8, [
                    (slotProps.option.imageUrl)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: slotProps.option.imageUrl,
                          style: {"width":"20px","margin-right":"3px"}
                        }, null, 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    _createElementVNode("label", _hoisted_10, _toDisplayString(slotProps.option.name), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Button, {
              label: "Đăng ký",
              icon: "pi pi-plus-circle",
              iconPos: "left",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.doRegister()))
            })
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Panel, {
      header: "Danh sách thành viên",
      class: "compact-panel-half"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_DataTable, {
            class: "compact-table compact-table-half",
            value: $setup.listReceiver,
            paginator: true,
            stripedRows: "",
            rows: 10,
            rowsPerPageOptions: [10,25,50],
            rowHover: true,
            paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
            globalFilterFields: ['zaloName'],
            currentPageReportTemplate: "Có tất cả {totalRecords} thành viên",
            filters: $setup.filters,
            "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event))
          }, {
            paginatorLeft: _withCtx(() => []),
            empty: _withCtx(() => [
              _hoisted_19
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "imageLink",
                header: "Ảnh đại diện",
                sortable: ""
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        src: slotProps.data.imageLink,
                        style: {"width":"60px"}
                      }, null, 8, _hoisted_16)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "zaloName",
                header: "Họ và tên",
                sortable: ""
              }),
              _createVNode(_component_Column, { header: "Tuỳ chọn" }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_Button, {
                        type: "button",
                        class: "p-button-danger",
                        label: "Xoá",
                        icon: "pi pi-trash",
                        onClick: ($event: any) => ($setup.doDelete(slotProps.data.id))
                      }, null, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "filters"])
        ])
      ]),
      _: 1
    })
  ], 64))
}